import React from "react";
import PageTop from "../../ui/page-top";
import SearchBar from "./ui/search-bar";
import SearchResults from "../../ui/search-results";
import { useParams } from "react-router-dom";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import useFetchSearch from "../../lib/hooks/use-fetch-search";



export default  function SearchQueryHome() {
  const par:any = useParams();
  const {products:results} =  useFetchSearch(par?.query);
  console.log("search results: ", results);
  
  return (
    <React.Fragment>
      <PageTop page={{ noheader: true }} />
      <div className="page-body py30">
        <h1>
          <u>{results.length}</u> result{results.length > 1 ? "s" : ""} for{" "}
          <u>"{decodeURI(par?.query)}"</u> Search
        </h1>
        <div className="py30">
          <SearchBar />
          <SearchResults results={results} />
        </div>
      </div>
    </React.Fragment>
  );
}
